<template>
	<v-menu class="d-block" offset-y>
		<template #activator="{ on, attrs }">
			<status-chip
				v-bind="{ ...attrs, status, severity, on: allowStatusTransition ? on : {} }"
			/>
		</template>
		<v-list>
			<v-list-item
				v-for="(item, index) in items"
				:key="index"
				class="list-item"
				@click="select(item)"
			>
				<v-list-item-title>{{ item.action }}</v-list-item-title>
			</v-list-item>
		</v-list>
	</v-menu>
</template>

<script>
import _ from "lodash";
import { alarmStatus } from "./status";
import StatusChip from "./StatusChip.vue";

export default {
	name: "StatusSelect",

	components: {
		StatusChip,
	},

	props: {
		status: String,
		severity: String,
	},

	data() {
		return {
			items: alarmStatus.filter(status => !status.system),
		};
	},

	computed: {
		allowStatusTransition() {
			return !this.status || this.status !== "NORMAL";
		}
	},

	methods: {
		capitalize: _.capitalize,

		select(item) {
			this.$emit("select", item);
		},
	},
};
</script>

<style lang="scss" scoped>
.list-item {
	min-height: 32px;
}
</style>
